module.exports = __webpack_public_path__ + "img/android.4668af7f.png";